export const API_PREFIX =
  process.env.NODE_ENV == "development"
    ? "//sharepaymkinpre.lizhi.fm"
    : "//sharepaymkin.lizhi.fm";
